import React, { useState, useEffect } from 'react'
import LiveModal from 'live/components/ui/Modal'
import styled from 'styled-components'
import { Modal } from 'react-bootstrap'
import i18n from 'live/services/i18n'
import theme from 'live/services/theme'
import EditQuery from './EditQuery'

type ModalEditQueryProps = {
    showModal: boolean
    setShowModal: Function
    applyQuery: (query:string) => void
    defaultQuery: string
    manualQuery: string
}

function ModalEditQuery(props: ModalEditQueryProps) {
    const {
        showModal,
        setShowModal,
        applyQuery,
        defaultQuery,
        manualQuery
    } = props

    const [code, setCode] = useState(manualQuery || defaultQuery)

    useEffect(() => {
        setCode(manualQuery || defaultQuery)
    }, [manualQuery, defaultQuery])

    const disableApply = (!!manualQuery && manualQuery === code) || (!manualQuery && defaultQuery === code)

    return (
        <Container>
            <Main>
                <div className="importExport">
                    <StyledLiveModal show={showModal} onHide={() => setShowModal(false)}>
                        <Modal.Header>
                            <Modal.Title>
                                <span className="capitalize">{i18n('Edit query')}</span>
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <EditQuery defaultQuery={defaultQuery} code={code} setCode={setCode} />
                        </Modal.Body>
                        <Modal.Footer>
                            <button
                                type="button"
                                id="btnOk"
                                className="btn btn-primary btn-lg btn-bold"
                                onClick={() => {
                                    applyQuery(code)
                                    setShowModal(false)
                                }}
                                disabled={disableApply}
                            >
                                {i18n('Apply')}
                            </button>
                            <span>
                                <span className="submit-or-cancel">{i18n('Or')} </span>
                                <a
                                    onClick={() => {
                                        setShowModal(false)
                                        setCode(manualQuery || defaultQuery)
                                    }}
                                >
                                    {i18n('Cancel')}
                                </a>
                            </span>
                        </Modal.Footer>
                    </StyledLiveModal>
                </div>
            </Main>
        </Container>
    )
}

export default ModalEditQuery

const Container = styled.div``

const Main = styled.div`
    .titleImport {
        height: 14px;
        font-family: 'SourceSansPro-Regular', Arial, 'Helvetica Neue', Helvetica, sans-serif;
        font-size: 11px;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: right;
        color: #606a80;
        margin-right: 8px;
    }
    .fileImportExport {
        cursor: pointer;
    }
    .notAllowed,
    .notAllowed .fa {
        cursor: not-allowed;
    }
    .fa {
        width: 12px;
        height: 16px;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: right;
        color: #37a3ef;
        cursor: pointer;
    }
`

const StyledLiveModal = styled(LiveModal)`
    .modal-dialog {
        width: 824px;
        height: 432px;
    }
    @media (max-width: 800px) {
        .modal-dialog {
            width: 824px;
            height: 432px;
        }
    }
    z-index: 1040;
    .capitalize {
        text-transform: capitalize;
    }
    .modal-header {
        position: relative;
        padding: 0;
    }
    .modal-body {
        background: #eeeeee;
        padding: 0;
        overflow: auto;
        position: relative;
        max-height: 400px;
    }
    .btn {
        border-radius: 0;
    }
    .modal-footer {
        border-top: none;
    }
    .modal-title {
        width: 100%;
        padding-left: 23px;
        color: #364159;
        font-style: normal;
        font-weight: normal;
        font-family: ${theme['font-regular']};
        font-size: 18px;
    }
`
